import { CategoryDto } from '@careapp-group/ng-sdk';
import { createSelector } from '@ngrx/store';
import * as actions from '../actions/index';
import { CAAction } from '../actions/index';
import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';

export type State = DataListState<CategoryDto> & {
  byOrganisation: { [key: string]: CategoryDto[] };
};

class MemoCategoriesState extends ReducerStateFactory<CategoryDto> {
  readonly initialState: State = {
    ...INITIAL_DATA_LIST_STATE,
    byOrganisation: {},
  };

  constructor() {
    super(actions.MemoCategories);
  }

  public reducer(state: State, action: CAAction) {
    switch (action.type) {
      case actions.MemoCategories.RESPONSE_SUCCESS_BY_ORG_ID:
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload.id]: false,
          },
          byOrganisation: {
            ...state.byOrganisation,
            [action.payload.id]: action.payload.data,
          },
        };
      case actions.MemoCategories.RESPONSE_SUCCESS_ADD_BY_ID:
        const existing = state.byOrganisation[action.payload.organisationId] || [];
        const categories = existing.reduce((a, b) => ({ ...a, [b.id]: b }), {});
        categories[action.payload.data.id] = action.payload.data;
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload.organisationId]: false,
          },
          byOrganisation: {
            ...state.byOrganisation,
            [action.payload.organisationId]: Object.keys(categories).map((id) => categories[id]),
          },
        };
      case actions.MemoCategories.RESPONSE_SUCCESS_REMOVE_BY_ID:
        const byOrganisation = { ...state.byOrganisation };
        byOrganisation[action.payload.organisationId] = byOrganisation[
          action.payload.organisationId
        ].filter((item) => item.id !== action.payload.categoryId);
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload.organisationId]: false,
          },
          byOrganisation,
        };
    }

    return super.reducer(state, action);
  }
}

export const state = new MemoCategoriesState();

export function reducer(...args) {
  return state.reducer.apply(state, args);
}

export const createSelectors = (rootReducer: any) => ({
  getOrganisationCategories: createSelector(rootReducer, (state: State) => state.byOrganisation),
});
